import { useFormContext } from 'react-hook-form';
import { Flex, Typography, Checkbox } from '@creditas-ui/react';
import { pipe } from 'fp-ts/lib/function';
import { Messages } from '~/components/Messages';
import { useRegisterWithEvents } from '~/hooks';
import type { JSX } from 'react';
import type { FieldCheckboxSchema } from '~/shared/domain/models';

export type FieldCheckProps = {
  data: FieldCheckboxSchema;
};

type Component = (props: FieldCheckProps) => JSX.Element;

export const FieldCheckbox: Component = ({ data }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const { name, label, defaultValue, disabled, options, messages, isPII } = data;

  const { registerWithEvents } = useRegisterWithEvents();
  const eventsRegister = registerWithEvents(data, isPII);

  const registerField = pipe(register, eventsRegister);

  return (
    <Flex flexDirection="column">
      {label && (
        <Typography variant="bodyMdRegular" component="label">
          {label}:
        </Typography>
      )}
      {options.map((option) => (
        <Checkbox
          {...registerField(name)}
          disabled={disabled}
          defaultChecked={defaultValue?.includes(option.value)}
          key={option.value}
          label={option.label}
          value={option.value}
          id={option.value}
        />
      ))}

      <Messages messages={messages} errors={errors} name={name} />
    </Flex>
  );
};
